import React from "react";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import "./App.css";
import { Login } from "./pages/login";
import { Dashboard } from "./pages/private/dashboard";
import { useSelector } from "react-redux";
import { IApplicationState } from "./state/ducks";
import { AuthReducerState } from "./state/ducks/auth";
import { ConfigProvider } from "./components/config-provider";

interface PrivateRouteProps {
	component: any;
	isAuthenticated: boolean;
	[key: string]: unknown;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = (props) => {
	const { component, isAuthenticated, ...rest } = props;

	const routeComponent = (props: any) =>
		isAuthenticated ? (
			React.createElement(component, props)
		) : (
			<Redirect to={{ pathname: "/" }} />
		);
	return <Route {...rest} render={routeComponent} />;
};

export const App: React.FC = () => {
	const auth = useSelector<IApplicationState, AuthReducerState>(
		(state) => state.auth
	);

	return (
		<ConfigProvider>
			<Router>
				<Route exact path="/" component={Login} />
				<PrivateRoute
					path="/dashboard"
					component={Dashboard}
					isAuthenticated={!!auth.token.isAuthenticated}
				/>
			</Router>
		</ConfigProvider>
	);
};

export default App;
